<template>
  <div id="search-form-container" class="wrapper">
    <header class="nav-up">
      <h5 v-on:click.stop.prevent="scrollToForm()"><i class="fal fa-search"></i> What are you in the mood for?</h5>
      <ul class="pure-menu-list main-menu" v-if="isLoggedIn">
        <li class="pure-menu-item pure-menu-has-children pure-menu-allow-hover account-menu-item" v-if="isLoggedIn"><a href="#" v-on:click.stop.prevent="menuOpenClick" class="pure-menu-link"><i class="fas fa-bars"></i></a>
          <ul class="pure-menu-children">
            <li class="pure-menu-item"><router-link to="/lists" class="pure-menu-link">Lists</router-link></li>
            <li class="pure-menu-item"><router-link to="/account" class="pure-menu-link">Account</router-link></li>
          </ul>
        </li>
      </ul>
      <div v-else>
        <router-link to="/account" class="pure-button login-link">Login</router-link>
      </div>
    </header>
    <div class="search-form-intro">
      <div class="heading-wrap group">
        <h2>Welcome to Matrix.</h2>
        <ul class="pure-menu-list main-menu" v-if="isLoggedIn">
          <li class="pure-menu-item pure-menu-has-children pure-menu-allow-hover account-menu-item" v-if="isLoggedIn"><a href="#" v-on:click.stop.prevent="menuOpenClick" class="pure-menu-link"><i class="fas fa-bars"></i></a>
            <ul class="pure-menu-children">
              <li class="pure-menu-item"><router-link to="/lists" class="pure-menu-link">Lists</router-link></li>
              <li class="pure-menu-item"><router-link to="/account" class="pure-menu-link">Account</router-link></li>
            </ul>
          </li>
        </ul>
        <div v-else>
          <router-link to="/account" class="pure-button login-link">Login</router-link>
        </div>
      </div>
      <div class="primary-intro">
        <h4>Browse 20,000 films from the past century...</h4>
        <h5 v-on:click.stop.prevent="scrollToForm()"><i class="fal fa-search"></i> What are you in the mood for?</h5>
        <h4 class="search-heading" v-if="searchEnabled">Search</h4>
        <div class="pure-control-group search-term aa-input-container" id="aa-input-container" v-if="searchEnabled">
          <input id="search-term-top" class="aa-input-search" type="text" placeholder="Type an actor or director here" v-model="searchTerm" autocomplete="off">
        </div>
      </div>
      <div>
        <h4>Suggested for you <div class="refresh-trigger" v-on:click.stop.prevent="refreshSuggested"><i class="fal fa-sync"></i></div></h4>
      </div>
      <div class="movie-row">
        <ul v-images-loaded:on.progress="movieRowLoaded">
          <li v-for="(movieData, index) in topRowMovies" :data-id="movieData.id" class="movie-item">
            <div class="opt-title" v-on:click="doMovieSearch(actor.name, 'Cast')" v-if="index == 0">
              <div class="opt-title-inner">{{actor.name}}</div>
            </div>
            <div class="opt-title" v-on:click="doMovieSearch(genre, 'Genres')" v-if="index == 1">
              <div class="opt-title-inner">{{genre}}</div>
            </div>
            <div class="opt-title" v-on:click="doMovieSearch(director.name, 'Directors')" v-if="index == 2">
              <div class="opt-title-inner">{{director.name}}</div>
            </div>
            <div class="opt-title" v-on:click="doMovieSearch(genre2, 'Genres')" v-if="index == 3">
              <div class="opt-title-inner">{{genre2}}</div>
            </div>  
            <div class="movie-poster" v-on:click="selectMovie(index)">
              <img :src="movieData.Poster" :alt="movieData.Title"  />
            </div>
          </li>
        </ul>
      </div>
      <div class="selected-movie" v-if="selectedMovie">
        <MoviePanel :movieData="selectedMovie" :isSearch="false" />
      </div>
      <div class="two-numbers">
        <h4>Two numbers explain every film.</h4>
        <div id="tutorial-overlay" data-step="0">
        </div>
        <div class="quality-buzz-wrap">
          <div class="quality-wrap">
            <div class="qb-emphasis qb-emphasis-quality">Quality</div>
            <div class="quality-text">
              <p><span>Quality</span> distills 1.5bn ratings and 1m critic reviews - from IMDB, Metacritic, Letterboxd & Rotten Tomatoes - into <i>one unifying number</i>.</p>
            </div>
          </div>
          <span class="amp">&</span>
          <div class="buzz-wrap">
            <div class="qb-emphasis qb-emphasis-buzz">Buzz</div>
            <div class="buzz-text">
              <p><span>Buzz</span> measures a film's internet presence, by looking at <i>how many</i> ratings and reviews a film has had.</p>
            </div>
          </div>
        </div>
        <div class="qb-extra-trigger"><i class="fas fa-chevron-down"></i></div>
        <div class="qb-extra-wrap">
          <h4>And there are two types of good film.</h4>
          <p>A quarter of the films on Matrix are 75+ quality, or 'good'. That's more than <span>5,000</span> films. Adding buzz lets us split those films into <span>hits</span> and <span>gems</span>.</p>
          <div class="numbers-wrap group">
            <div class="hits-display">
              <h6>Hits</h6>
              <div class="quality-square first">
                <span class="score">75+</span>
                <span>Quality</span>
              </div>
              <div class="quality-square">
                <span class="score">75+</span>
                <span>Buzz</span>
              </div>
            </div>
            <div class="gems-display">
              <h6>Gems</h6>
              <div class="quality-square first">
                <span class="score">75+</span>
                <span>Quality</span>
              </div>
              <div class="quality-square">
                <span class="score"><75</span>
                <span>Buzz</span>
              </div>
            </div>
          </div>
          <p>Most good films are gems. As Hollywood knows, it's hard to make hits. There are fewer than <span>1,000</span> on Matrix.</p>
        </div>
      </div>
      <div>
        <h4>Popular on Matrix <div class="refresh-trigger" v-on:click.stop.prevent="refreshPopular"><i class="fal fa-sync" v-if="!popularLoading"></i><i class="fas fa-spinner" v-if="popularLoading"></i></div></h4>
      </div>
      <div class="movie-row popular-movie-row">
        <ul v-images-loaded:on.progress="movieRowLoaded">
          <li v-for="(movieData, index) in sliceMovies(0,4)" :data-id="movieData.id" :data-class="movieData.class" class="movie-item" v-on:click="selectMoviePopular(movieData)">
            <div class="movie-title">
              <div class="movie-title-inner">{{movieData.Title}}</div>
            </div>
            <div class="movie-poster">
              <img :src="movieData.Poster" :alt="movieData.Title"  />
            </div>
            <div class="numbers-wrap">
              <div class="quality-square">
                <span class="score">{{movieData.Quality}}</span>
                <span>Quality</span>
              </div>
              <div class="quality-square">
                <span class="score">{{movieData.Buzz}}</span>
                <span>Buzz</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="selected-movie" v-if="selectedMoviePopular">
        <MoviePanel :movieData="selectedMoviePopular" :isSelected="true" />
      </div>
      <div class="alt" id="pick-10">
        <h4>Pick a genre, and we'll select 10 films for you.</h4>
      </div>
    </div>
    <SearchForm :qTimeperiod="qTimeperiod" :qGenres="qGenres" :qQuality="qQuality" :qBuzz="qBuzz" :qSort="qSort" :qSearchField="qSearchField" :qSearchValue="qSearchValue" />
    <div id="video-overlay" v-if="viewingTrailer">
      <div class="container">
        <a href="#" v-on:click.stop.prevent="closeTrailerOverlay" class="modal-close"><i class="fal fa-times"></i></a>
        <div class="video-wrap" v-html="videoIframe"></div>
      </div>
    </div>
    <button class="pure-button" id="tutorial-next">Next</button>
    <button class="pure-button" id="tutorial-close">Close</button>
  </div>
</template>

<script>
  import firebase from 'firebase'
  import db from './firebaseInit'
  import imagesLoaded from 'vue-images-loaded'
  import SearchForm from './SearchForm.vue'
  import MoviePanel from './MoviePanel.vue'
  const crypto = require('crypto');

  export default {
    name: 'search',
    props: ['query', 'qTimeperiod', 'qGenres', 'qQuality', 'qBuzz', 'qSort', 'qSearchField', 'qSearchValue'],
    metaInfo: {
      title: 'Grapevine Matrix',
      // override the parent template and just use the above title only
      titleTemplate: null
    },
    directives: {
      imagesLoaded
    },
    data () {
      return {
        client: null,
        index: null,
        searchEnabled: false,
        randomMovies: [],
        topRowMovies: [],
        popularLoading: false,
        viewingTrailer: false,
        selectedMovie: null,
        selectedMoviePopular: null,
        searchTerm: null,
        selectedActors: [{"name":"Clint Eastwood","movies":18},{"name":"Robert De Niro","movies":16},{"name":"Michael Caine","movies":16},{"name":"G��rard Depardieu","movies":15},{"name":"Max von Sydow","movies":14},{"name":"Dustin Hoffman","movies":14},{"name":"Jeff Bridges","movies":13},{"name":"Al Pacino","movies":13},{"name":"Gene Hackman","movies":13},{"name":"Paul Newman","movies":12},{"name":"Tom Cruise","movies":11},{"name":"Jack Nicholson","movies":11},{"name":"Sean Connery","movies":11},{"name":"Catherine Deneuve","movies":11},{"name":"John Cusack","movies":11},{"name":"Liv Ullmann","movies":11},{"name":"Ed Harris","movies":11},{"name":"Burt Lancaster","movies":11},{"name":"Walter Matthau","movies":10},{"name":"Peter O'Toole","movies":10},{"name":"Jack Lemmon","movies":10},{"name":"Julianne Moore","movies":10},{"name":"Daniel Auteuil","movies":10},{"name":"Russell Crowe","movies":10},{"name":"Robert Redford","movies":10},{"name":"Ethan Hawke","movies":10},{"name":"Sidney Poitier","movies":10},{"name":"Woody Allen","movies":10},{"name":"Tom Hanks","movies":10},{"name":"Diane Keaton","movies":10},{"name":"Tony Chiu Wai Leung","movies":10},{"name":"Sean Penn","movies":9},{"name":"Jeanne Moreau","movies":9},{"name":"Gary Oldman","movies":9},{"name":"Denzel Washington","movies":9},{"name":"Ryan Gosling","movies":9},{"name":"Christian Bale","movies":9},{"name":"Daniel Day-Lewis","movies":9},{"name":"Warren Oates","movies":9},{"name":"Lee Marvin","movies":9},{"name":"Albert Finney","movies":9},{"name":"Steve Buscemi","movies":9},{"name":"Matt Damon","movies":9},{"name":"Ned Beatty","movies":9},{"name":"Robert Downey Jr.","movies":9},{"name":"Leonardo DiCaprio","movies":9},{"name":"Jake Gyllenhaal","movies":9},{"name":"Harrison Ford","movies":9},{"name":"Isabelle Adjani","movies":8},{"name":"Dirk Bogarde","movies":8},{"name":"Sam Neill","movies":8},{"name":"Jason Robards","movies":8},{"name":"Joseph Gordon-Levitt","movies":8},{"name":"Ben Kingsley","movies":8},{"name":"Sigourney Weaver","movies":8},{"name":"Dennis Hopper","movies":8},{"name":"Jane Fonda","movies":8},{"name":"John Malkovich","movies":8},{"name":"John Goodman","movies":8},{"name":"Johnny Depp","movies":8},{"name":"Kang-ho Song","movies":8},{"name":"Mark Ruffalo","movies":8},{"name":"Christopher Plummer","movies":8},{"name":"Juliette Binoche","movies":8},{"name":"Marcello Mastroianni","movies":8},{"name":"Bill Murray","movies":8},{"name":"Sissy Spacek","movies":8},{"name":"Li Gong","movies":8},{"name":"Isabelle Huppert","movies":8},{"name":"Alan Arkin","movies":8},{"name":"Harvey Keitel","movies":8},{"name":"Tatsuya Nakadai","movies":8},{"name":"Gr��goire Colin","movies":7},{"name":"John Wayne","movies":7},{"name":"Helena Bonham Carter","movies":7},{"name":"Cate Blanchett","movies":7},{"name":"Henry Fonda","movies":7},{"name":"Mads Mikkelsen","movies":7},{"name":"Martin Balsam","movies":7},{"name":"Leslie Cheung","movies":7},{"name":"Peter Sellers","movies":7},{"name":"Bruno Ganz","movies":7},{"name":"Tom Hardy","movies":7},{"name":"Kate Winslet","movies":7},{"name":"Richard Dreyfuss","movies":7},{"name":"Josh Brolin","movies":7},{"name":"Nicolas Cage","movies":7},{"name":"Donald Sutherland","movies":7},{"name":"Forest Whitaker","movies":7},{"name":"Tadanobu Asano","movies":7},{"name":"Bill Paxton","movies":7},{"name":"Yves Montand","movies":7},{"name":"Morgan Freeman","movies":7},{"name":"Jean-Louis Trintignant","movies":7},{"name":"Jeremy Renner","movies":7},{"name":"Barbara Hershey","movies":7},{"name":"Harry Dean Stanton","movies":7},{"name":"Erland Josephson","movies":7},{"name":"Billy Crudup","movies":7},{"name":"Melvyn Douglas","movies":7},{"name":"Michel Piccoli","movies":7},{"name":"Aamir Khan","movies":7},{"name":"Anna Karina","movies":7},{"name":"Chris Cooper","movies":7},{"name":"Ralph Fiennes","movies":7},{"name":"Willem Dafoe","movies":7},{"name":"James Coburn","movies":7},{"name":"Gena Rowlands","movies":7},{"name":"Geoffrey Rush","movies":7},{"name":"Faye Dunaway","movies":7},{"name":"Toshir�� Mifune","movies":7},{"name":"George Clooney","movies":7},{"name":"Maggie Cheung","movies":7},{"name":"Stellan Skarsg��rd","movies":6},{"name":"Andr�� Dussollier","movies":6},{"name":"Albert Brooks","movies":6},{"name":"Kristin Scott Thomas","movies":6},{"name":"John Cleese","movies":6},{"name":"Laura Dern","movies":6},{"name":"Edward Norton","movies":6},{"name":"Philip Seymour Hoffman","movies":6},{"name":"Laura Linney","movies":6},{"name":"James Cromwell","movies":6},{"name":"Woody Harrelson","movies":6},{"name":"Martin Sheen","movies":6},{"name":"Matthew Broderick","movies":6},{"name":"Julie Christie","movies":6},{"name":"James Caan","movies":6},{"name":"Frances McDormand","movies":6},{"name":"K��ji Yakusho","movies":6},{"name":"Kevin Bacon","movies":6},{"name":"Hugo Weaving","movies":6},{"name":"Fernando Rey","movies":6},{"name":"John Gielgud","movies":6},{"name":"Jean-Pierre L��aud","movies":6},{"name":"Alfred Molina","movies":6},{"name":"Helen Mirren","movies":6},{"name":"Charlotte Rampling","movies":6},{"name":"Roy Scheider","movies":6},{"name":"Mark Hamill","movies":6},{"name":"Tommy Lee Jones","movies":6},{"name":"Jean-Paul Belmondo","movies":6},{"name":"Meryl Streep","movies":6},{"name":"Ewan McGregor","movies":6},{"name":"Robert Duvall","movies":6},{"name":"Jessica Lange","movies":6},{"name":"Carrie Fisher","movies":6},{"name":"Jon Voight","movies":6},{"name":"Tom Courtenay","movies":6},{"name":"Gael Garc�_a Bernal","movies":6},{"name":"Yun-Fat Chow","movies":6},{"name":"Eric Idle","movies":6},{"name":"Judi Dench","movies":6},{"name":"William Hurt","movies":6},{"name":"Jackie Chan","movies":6},{"name":"Reese Witherspoon","movies":6},{"name":"Ellen Burstyn","movies":6},{"name":"Bruce Willis","movies":6},{"name":"Lili Taylor","movies":6},{"name":"Ron Livingston","movies":6},{"name":"Ingrid Thulin","movies":6},{"name":"George C. Scott","movies":6},{"name":"Audrey Hepburn","movies":6},{"name":"Steve McQueen","movies":6},{"name":"Claudia Cardinale","movies":6},{"name":"Simon Yam","movies":6},{"name":"Kevin Costner","movies":6},{"name":"Bruce Dern","movies":6},{"name":"Jack Warden","movies":6},{"name":"Mia Farrow","movies":6},{"name":"Vincent Cassel","movies":5},{"name":"Terence Stamp","movies":5},{"name":"Chris Hemsworth","movies":5},{"name":"Joaquin Phoenix","movies":5},{"name":"Seymour Cassel","movies":5},{"name":"Byung-hun Lee","movies":5},{"name":"Jessica Chastain","movies":5},{"name":"Hugh Jackman","movies":5},{"name":"Ben Gazzara","movies":5},{"name":"John Cassavetes","movies":5},{"name":"Dan Aykroyd","movies":5},{"name":"Marlon Brando","movies":5},{"name":"Peter Fonda","movies":5},{"name":"Michael Fassbender","movies":5},{"name":"Jeremy Irons","movies":5},{"name":"Javier Bardem","movies":5},{"name":"Daniel Craig","movies":5},{"name":"Anthony Hopkins","movies":5},{"name":"Keanu Reeves","movies":5},{"name":"Tim Roth","movies":5},{"name":"Tsutomu Yamazaki","movies":5},{"name":"Jean-Claude Brialy","movies":5},{"name":"Fran�_ois Cluzet","movies":5},{"name":"Annette Bening","movies":5},{"name":"Denis Lavant","movies":5},{"name":"Mickey Rourke","movies":5},{"name":"Marisa Tomei","movies":5},{"name":"Oliver Reed","movies":5},{"name":"Brad Pitt","movies":5},{"name":"Gunnar Bj�_rnstrand","movies":5},{"name":"James Fox","movies":5},{"name":"Richard Burton","movies":5},{"name":"Timothy Spall","movies":5},{"name":"Alan Bates","movies":5},{"name":"Susan Sarandon","movies":5},{"name":"David Warner","movies":5},{"name":"Vanessa Redgrave","movies":5},{"name":"Samuel L. Jackson","movies":5},{"name":"Jeroen Krabb��","movies":5},{"name":"Hanna Schygulla","movies":5},{"name":"Joan Allen","movies":5},{"name":"Margit Carstensen","movies":5},{"name":"Ben Affleck","movies":5},{"name":"Danny Aiello","movies":5},{"name":"Nicole Kidman","movies":5},{"name":"Chris Evans","movies":5},{"name":"David Gulpilil","movies":5},{"name":"Steve Martin","movies":5},{"name":"Takeshi Kitano","movies":5},{"name":"Sandrine Bonnaire","movies":5},{"name":"Kang-sheng Lee","movies":5},{"name":"Kirk Douglas","movies":5},{"name":"Guy Pearce","movies":5},{"name":"Julie Andrews","movies":5},{"name":"Richard Attenborough","movies":5},{"name":"Paddy Considine","movies":5},{"name":"Niels Arestrup","movies":5},{"name":"Tim Robbins","movies":5},{"name":"Emmanuelle B��art","movies":5},{"name":"Tilda Swinton","movies":5},{"name":"Warren Beatty","movies":5},{"name":"Mathieu Amalric","movies":5},{"name":"Jeff Daniels","movies":5},{"name":"Barry Pepper","movies":5},{"name":"Kurt Russell","movies":5},{"name":"Jim Broadbent","movies":5},{"name":"Brian Dennehy","movies":5},{"name":"Julie Delpy","movies":5},{"name":"Joe Pesci","movies":5},{"name":"Delphine Seyrig","movies":5},{"name":"David Strathairn","movies":5},{"name":"Anthony Quinn","movies":5},{"name":"Alain Delon","movies":5},{"name":"Edward Fox","movies":5},{"name":"Billy Bob Thornton","movies":5},{"name":"Anne Bancroft","movies":5}],
        selectedDirectors: [{"name":"Woody Allen","movies":18},{"name":"Steven Spielberg","movies":17},{"name":"Eric Rohmer","movies":17},{"name":"Martin Scorsese","movies":16},{"name":"Fran�_ois Truffaut","movies":14},{"name":"Ingmar Bergman","movies":14},{"name":"Rainer Werner Fassbinder","movies":14},{"name":"Ethan Coen","movies":13},{"name":"Joel Coen","movies":13},{"name":"Mike Leigh","movies":12},{"name":"Stephen Frears","movies":12},{"name":"Sidney Lumet","movies":12},{"name":"Clint Eastwood","movies":12},{"name":"Jean-Luc Godard","movies":12},{"name":"Roman Polanski","movies":11},{"name":"Yimou Zhang","movies":11},{"name":"Robert Altman","movies":10},{"name":"Ken Loach","movies":10},{"name":"Luis Bu��uel","movies":10},{"name":"Werner Herzog","movies":10},{"name":"Blake Edwards","movies":9},{"name":"Christopher Nolan","movies":9},{"name":"Abbas Kiarostami","movies":9},{"name":"Quentin Tarantino","movies":9},{"name":"Jim Jarmusch","movies":9},{"name":"Krzysztof Kieslowski","movies":9},{"name":"Pedro Almod�_var","movies":9},{"name":"Steven Soderbergh","movies":9},{"name":"Akira Kurosawa","movies":8},{"name":"Guy Maddin","movies":8},{"name":"John Sayles","movies":8},{"name":"Andrei Tarkovsky","movies":8},{"name":"Ridley Scott","movies":8},{"name":"Robert Bresson","movies":8},{"name":"Hirokazu Koreeda","movies":8},{"name":"Louis Malle","movies":8},{"name":"Satyajit Ray","movies":8},{"name":"Peter Weir","movies":8},{"name":"Jacques Rivette","movies":8},{"name":"John Cassavetes","movies":8},{"name":"Sam Peckinpah","movies":8},{"name":"Stanley Kubrick","movies":7},{"name":"Norman Jewison","movies":7},{"name":"Milos Forman","movies":7},{"name":"Wim Wenders","movies":7},{"name":"Brian De Palma","movies":7},{"name":"Paul Thomas Anderson","movies":7},{"name":"John Frankenheimer","movies":7},{"name":"Terry Gilliam","movies":7},{"name":"Kar Wai Wong","movies":7},{"name":"Sh��hei Imamura","movies":7},{"name":"Ang Lee","movies":7},{"name":"Edgar Wright","movies":6},{"name":"Jean-Pierre Melville","movies":6},{"name":"Hal Ashby","movies":6},{"name":"Paul Verhoeven","movies":6},{"name":"Federico Fellini","movies":6},{"name":"Bertrand Tavernier","movies":6},{"name":"Sergio Leone","movies":6},{"name":"John Woo","movies":6},{"name":"John Schlesinger","movies":6},{"name":"Emir Kusturica","movies":6},{"name":"William Friedkin","movies":6},{"name":"Jean-Pierre Dardenne","movies":6},{"name":"Luc Dardenne","movies":6},{"name":"Jafar Panahi","movies":6},{"name":"Peter Jackson","movies":6},{"name":"David Lynch","movies":6},{"name":"Aki Kaurism�_ki","movies":6},{"name":"Béla Tarr","movies":6},{"name":"Alain Resnais","movies":6},{"name":"Ming-liang Tsai","movies":6},{"name":"David Fincher","movies":6},{"name":"James Cameron","movies":6},{"name":"John Huston","movies":6},{"name":"Bille August","movies":6},{"name":"Pier Paolo Pasolini","movies":6},{"name":"Michael Mann","movies":6},{"name":"Rob Reiner","movies":6},{"name":"Lars von Trier","movies":6},{"name":"Ron Howard","movies":6},{"name":"Richard Linklater","movies":6},{"name":"Alan Parker","movies":6},{"name":"Takeshi Kitano","movies":5},{"name":"Luchino Visconti","movies":5},{"name":"Robert Aldrich","movies":5},{"name":"Patrice Leconte","movies":5},{"name":"Oliver Stone","movies":5},{"name":"Alejandro Jodorowsky","movies":5},{"name":"Martin Ritt","movies":5},{"name":"Johnnie To","movies":5},{"name":"Alexander Payne","movies":5},{"name":"Richard Donner","movies":5},{"name":"Richard Lester","movies":5},{"name":"Theodoros Angelopoulos","movies":5},{"name":"Peter Greenaway","movies":5},{"name":"Don Siegel","movies":5},{"name":"John Boorman","movies":5},{"name":"Peter Bogdanovich","movies":5},{"name":"Jacques Audiard","movies":5},{"name":"Danny Boyle","movies":5},{"name":"Robert Benton","movies":5},{"name":"Majid Majidi","movies":5},{"name":"Barry Levinson","movies":5},{"name":"Claude Chabrol","movies":5},{"name":"Paul Greengrass","movies":5},{"name":"Ousmane Sembene","movies":5},{"name":"Spike Lee","movies":5},{"name":"Gus Van Sant","movies":5},{"name":"Sydney Pollack","movies":5},{"name":"Sam Raimi","movies":5},{"name":"Denis Villeneuve","movies":5},{"name":"George Roy Hill","movies":5},{"name":"Asghar Farhadi","movies":5},{"name":"Tim Burton","movies":5},{"name":"David Cronenberg","movies":5},{"name":"Atom Egoyan","movies":5},{"name":"Bahman Ghobadi","movies":5},{"name":"Michelangelo Antonioni","movies":5},{"name":"Alfonso Cuarón","movies":5},{"name":"Billy Wilder","movies":5},{"name":"Joon-ho Bong","movies":5}],
        selectedGenres: ['Horror', 'Thriller', 'Crime', 'Mystery', 'Drama', 'Comedy', 'Sci-Fi', 'Romance', 'War', 'Western', 'Fantasy', 'Action'],
        actor: '',
        director: '',
        genre: '',
        genre2: '',
        isLoggedIn: false
      }
    },
    watch: {
      qSearchValue (newValue) {
        if (newValue && newValue != '') {
          this.searchTerm = newValue
        }
      },
    },
    created () {
      let vm = this
      vm.client = algoliasearch('EQ4MPZHE99', 'b883b4278df4fd23853990e7ed74551d')
      vm.index = vm.client.initIndex(vm.dataIndex)

      if (this.qSearchValue && this.qSearchValue != '') {
        this.searchTerm = this.qSearchValue
      }
      
      firebase.auth().onAuthStateChanged(function (user) {
        vm.user = null
        vm.name = ''
        vm.email = ''
        vm.photo = ''
        vm.userId = ''
        if (user) {
          vm.currentUserID = user.uid
          vm.$globals.currentUserID = user.uid
          vm.isLoggedIn = true
          firebase.database().ref('users/' + user.uid).once('value', function (snapshot) {
            if (snapshot.val()) {
              vm.username = snapshot.val().username
              vm.$globals.userUsername = vm.username
            }
          })
        } else {
          vm.isLoggedIn = false
        }
      })
      this.actor = this.selectedActors[Math.floor(Math.random() * this.selectedActors.length)]
      this.director = this.selectedDirectors[Math.floor(Math.random() * this.selectedDirectors.length)]
      this.genre = this.selectedGenres[Math.floor(Math.random() * this.selectedGenres.length)]
      this.genre2 = this.selectedGenres[Math.floor(Math.random() * this.selectedGenres.length)]
      this.getTopRowMovies()
      this.refreshPopular()
      vm.$eventHub.$on('load-movie-trailer', function (videoID) {
        console.log('load-movie-trailer')
        vm.viewTrailer(videoID)
      })
      vm.$eventHub.$on('hide-movie-panel', function (movieID) {
        console.log('hide-movie-panel')
        vm.hideSelectedMovie(movieID)
      })
      // vm.$eventHub.$on('do-movie-search-selected', function (triggeredSearch, triggeredField) {
      //   this.$eventHub.$emit('do-movie-search-selected', triggeredSearch, triggeredField)
      // })
    },
    beforeDestroy () {
      this.$eventHub.$off('load-movie-trailer')
      this.$eventHub.$off('hide-movie-panel')
    },
    methods: {
      getTopRowMovies: function () {
        let vm = this
        var client = algoliasearch('EQ4MPZHE99', 'b883b4278df4fd23853990e7ed74551d')
        var queries = [{
          indexName: 'movies',
          params: {
            filters: 'Cast: "' + vm.actor.name + '"',
            hitsPerPage: 20
          }
        }, {
          indexName: 'movies',
          params: {
            filters: 'Directors: "' + vm.director.name + '"',
            hitsPerPage: 20
          }
        }, {
          indexName: 'movies',
          params: {
            filters: 'Genres:' + vm.genre,
            hitsPerPage: 20
          }
        }];

        client.search(queries).then(responses => {
          // Response from Algolia:
          // https://www.algolia.com/doc/api-reference/api-methods/search/#response-format
          var actorMovies = responses.results[0].hits
          var directorMovies = responses.results[1].hits
          var genreMovies = responses.results[2].hits
          var actorMovie = actorMovies[Math.floor(Math.random() * actorMovies.length)]
          if (actorMovie.PosterPath) {
            actorMovie.Poster = 'https://image.tmdb.org/t/p/w185' + actorMovie.PosterPath.replace(/ /g, "")
          }
          
          var genreMovie = genreMovies[Math.floor(Math.random() * genreMovies.length)]
          var genreMovie2 = genreMovies[Math.floor(Math.random() * genreMovies.length)]
          if (genreMovie.PosterPath) {
            genreMovie.Poster = 'https://image.tmdb.org/t/p/w185' + genreMovie.PosterPath.replace(/ /g, "")
          }
          if (genreMovie2.PosterPath) {
            genreMovie2.Poster = 'https://image.tmdb.org/t/p/w185' + genreMovie2.PosterPath.replace(/ /g, "")
          }

          var directorMovie = directorMovies[Math.floor(Math.random() * directorMovies.length)]
          if (directorMovie.PosterPath) {
            directorMovie.Poster = 'https://image.tmdb.org/t/p/w185' + directorMovie.PosterPath.replace(/ /g, "")
          }

          vm.topRowMovies.push(actorMovie)
          vm.topRowMovies.push(genreMovie)
          vm.topRowMovies.push(directorMovie)
          vm.topRowMovies.push(genreMovie2)

        })
      },
      refreshSuggested: function () {
        this.topRowMovies = []
        this.actor = this.selectedActors[Math.floor(Math.random() * this.selectedActors.length)]
        this.director = this.selectedDirectors[Math.floor(Math.random() * this.selectedDirectors.length)]
        this.genre = this.selectedGenres[Math.floor(Math.random() * this.selectedGenres.length)]
        this.genre2 = this.selectedGenres[Math.floor(Math.random() * this.selectedGenres.length)]
        this.getTopRowMovies()
      },
      refreshPopular: function () {
        this.randomMovies = []
        this.getRandomMovies()
      },
      getRandomMovies: function () {
        let vm = this
        var limit = 125
        var buzzLower = 75
        var buzzHigher = 101
        vm.popularLoading = true
        for (var i = 0; i < limit; i++) {
          if (vm.randomMovies.length == 4) {
            break
          }
          var random = crypto.randomBytes(4).readUInt32BE(0, true) + crypto.randomBytes(4).readUInt32BE(0, true)
          let moviesRef = db.collection('movies')
          var queryRef = moviesRef.where('random', '>', random).orderBy('random').limit(1)
          queryRef.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var movieData = doc.data()
              movieData.docID = doc.id
              if (movieData.Quality >= 75 && movieData.Buzz >= 75) {
                movieData.class = 'high'
              } else if (movieData.Quality >= 75 && movieData.Buzz >= 25) {
                movieData.class = 'mid'
              } else {
                movieData.class = 'low'
              }
              if (doc.exists && !vm.checkMoviePresent(vm.randomMovies, movieData.id, true) && movieData.PosterPath && movieData.Quality >= 75 && movieData.Buzz >= buzzLower && movieData.Buzz < buzzHigher) {
                if (movieData.PosterPath) {
                  movieData.Poster = 'https://image.tmdb.org/t/p/w342/' + movieData.PosterPath.replace(/ /g, "")
                }
                if (movieData.Title.length > 29) {
                  movieData.Title = movieData.Title.substring(0, 26) + '...'
                }
                if (!vm.checkMoviePresent(vm.randomMovies, movieData.docID, true)) {
                  vm.randomMovies.push(movieData)
                  if (buzzLower == 75) {
                    buzzLower = 25
                    buzzHigher = 75
                  } else {
                    buzzLower = 75
                    buzzHigher = 101
                  }
                }
              } else if (movieData.PosterPath && movieData.Quality >= 75 && movieData.Buzz >= buzzLower && movieData.Buzz < buzzHigher) {
                queryRef = moviesRef.where('random', '<=', random).orderBy('random', 'desc').limit(1)
                queryRef.get().then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    if (doc.exists && doc.data().PosterPath) {
                      var movieData = doc.data()
                      movieData.docID = doc.id
                      if (movieData.PosterPath) {
                        movieData.Poster = 'https://image.tmdb.org/t/p/w342/' + movieData.PosterPath.replace(/ /g, "")
                      }
                      if (movieData.Title.length > 25) {
                        movieData.Title = movieData.Title.substring(0, 25) + '...'
                      }
                      if (!vm.checkMoviePresent(vm.randomMovies, movieData.docID, true)) {
                        vm.randomMovies.push(movieData)
                        if (buzzLower == 75) {
                          buzzLower = 25
                          buzzHigher = 75
                        } else {
                          buzzLower = 75
                          buzzHigher = 101
                        }
                      }
                    }
                  })
                })
              }
            })
          })
          if (i + 1 === limit) {
            console.log('finished getRandomMovies')
            vm.popularLoading = false
          }
        }
      },
      sliceMovies: function (start, end) {
        return this.randomMovies.slice(start, end);
      },
      checkMoviePresent: function (inArr, docID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].docID === docID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      movieRowLoaded: function (instance, image) {
        const result = image.isLoaded ? 'loaded' : 'broken';
        var i = $(image.img).parents('.movie-item').index()
        $(image.img).parents('.movie-item').transition({
          opacity: 1,
          delay: i*200,
          duration: 800,
          complete: function () {
            $(image.img).parents('.movie-item').addClass('item-animated');
          }
        });
      },
      viewTrailer: function (videoID) {
        this.videoIframe = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoID + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'
        this.viewingTrailer = true
      },
      closeTrailerOverlay: function () {
        this.viewingTrailer = false
        $('#video-overlay').find('.video-wrap').empty()
      },
      doMovieSearch: function (triggeredSearch, triggeredField) {
        this.$eventHub.$emit('do-movie-search', triggeredSearch, triggeredField)
      },
      scrollToForm: function () {
        $('html, body').animate({ scrollTop: $('#pick-10').offset().top - 5 }, 'slow')
      },
      selectMovie: function (index) {
        if (index == 0) {
          this.doMovieSearch(this.actor.name, 'Cast')
        } else if (index == 1) {
          this.doMovieSearch(this.genre, 'Genres')
        } else if (index == 2) {
          this.doMovieSearch(this.director.name, 'Directors')
        } else if (index == 3) {
          this.doMovieSearch(this.genre2, 'Genres')
        }
      },
      selectMoviePopular: function (movieData) {
        this.selectedMoviePopular = movieData
      },
      hideSelectedMovie: function (movieID) {
        if (this.selectedMovie && this.selectedMovie.id == movieID) {
          this.selectedMovie = null
        } else if (this.selectedMoviePopular && this.selectedMoviePopular.id == movieID) { 
          this.selectedMoviePopular = null
        }
      },
      menuOpenClick: function () {

      }
    },
    mounted: function () {

      let vm = this
      var directorsIndex = vm.client.initIndex('directors')
      var actorsIndex = vm.client.initIndex('actors')
      var haltProgress = false

      $(document).on('click touchstart', '.qb-extra-trigger', function(e) {
        e.stopPropagation();
        $(this).next('div').stop().slideToggle(500);
      });

      $(document).on('focus', '#search-term-top', function(e) {
        $('html, body').animate({ scrollTop: $('#search-term-top').offset().top - 40 }, 'slow')
      })

      $(document).on('click touchend', '.qb-emphasis', function(e) {
        $('html, body').animate({ scrollTop: $('.quality-buzz-wrap').offset().top - 20 }, 'slow')
        $('.tutorial-next').css('display', 'inline-block')
        $('.quality-buzz-wrap').css({
          'z-index': 99999,
          'color': '#222'
        });
        $('.quality-wrap').css({
          'background' : '#fff'
        });
        $('#tutorial-overlay').fadeIn(300);
        $('#tutorial-next').fadeIn(300);
        $('#tutorial-close').fadeIn(300);
      })

      $(document).on('click touchend', '#tutorial-next', function(e) {

        if (haltProgress) {
          return;
        } else {
          haltProgress = true;
        }
        var step = parseInt($('#tutorial-overlay').attr('data-step'), 10) + 1
        $('#tutorial-overlay').attr('data-step', step)

        if (step == 1) {
          $('.quality-wrap').css({
            'background' : ''
          });
          $('.buzz-wrap').css({
            'background' : '#fff'
          });
          setTimeout(function() {
            haltProgress = false
          }, 200);
        } else if (step == 2) {
          $('.qb-extra-wrap').stop().slideDown(500, function () {
            $('html, body').animate({ scrollTop: $('.qb-extra-wrap').offset().top - 40 }, 'slow')
            $('.quality-buzz-wrap').css('z-index', '');
            $('.qb-extra-wrap').css('z-index', 99999);
            $('.buzz-wrap').css({
              'background' : ''
            });
            $('.qb-extra-wrap').css({
              'background' : '#fff'
            });
            $('#tutorial-next').hide(400)
            setTimeout(function() {
              haltProgress = false
            }, 200);
          });
        }
      })

      $(document).on('click touchend', '#tutorial-close', function(e) {
        $('#tutorial-overlay').attr('data-step', 0)
        $('#tutorial-next').fadeOut(300);
        $('#tutorial-close').fadeOut(300);
        $('#tutorial-overlay').fadeOut(300, function() {
          $('#tutorial-overlay').css('z-index',''); 
          $('.qb-extra-wrap').css('z-index','');
          $('.quality-buzz-wrap').css('z-index','');
        });
        $('.quality-text, .buzz-text, .qb-extra-wrap').css({
          'background' : ''
        });
      })

      autocomplete(
        '#search-term-top',
        {
          debug: true,
          templates: {
            dropdownMenu:
              '<div class="aa-dataset-actor"></div>' +
              '<div class="aa-dataset-director"></div>',
          },
        },
        [
          {
            source: autocomplete.sources.hits(actorsIndex, {hitsPerPage: 5}),
            displayKey: 'name',
            name: 'Cast',
            templates: {
              header: '<div class="aa-suggestions-category">Actors</div>',
              suggestion: function(suggestion) {
                return (
                  '<div><span>' +
                  suggestion._highlightResult.name.value +
                  '</span></div>'
                );
              },
              empty: '<div class="aa-empty">No matching actors</div>',
            },
          },
          {
            source: autocomplete.sources.hits(directorsIndex, {hitsPerPage: 7}),
            displayKey: 'name',
            name: 'Directors',
            templates: {
              header: '<div class="aa-suggestions-category">Directors</div>',
              suggestion: function(suggestion) {
                return (
                  '<div><span>' +
                  suggestion._highlightResult.name.value +
                  '</span></div>'
                );
              },
              empty: '<div class="aa-empty">No matching directors</div>',
            },
          },
        ]
      ).on('autocomplete:selected', function(event, suggestion, dataset) {
        vm.doMovieSearch(suggestion.name, dataset)
      });


      // Hide Header on on scroll down
      var didScroll;
      var lastScrollTop = 0;
      var delta = 5;
      var navbarHeight = $('header').outerHeight();

      $(window).scroll(function(event){
          didScroll = true;
      });

      setInterval(function() {
          if (didScroll) {
              hasScrolled();
              didScroll = false;
          }
      }, 250);

      function hasScrolled() {
          if ($('.search-form').length <= 0) {
            return
          }
          
          var st = $(window).scrollTop();
          var start = $('.search-form').offset().top + 100;

          if (st < start) {
            $('header').removeClass('nav-down').addClass('nav-up');
            return;
          }

          // Make sure they scroll more than delta
          if(Math.abs(lastScrollTop - st) <= delta)
              return;
          
          // If they scrolled down and are past the navbar, add class .nav-up.
          // This is necessary so you never see what is "behind" the navbar.
          if (st > lastScrollTop && st > navbarHeight){
              // Scroll Down
              $('header').removeClass('nav-down').addClass('nav-up');
          } else {
              // Scroll Up
              if(st + $(window).height() < $(document).height()) {
                  $('header').removeClass('nav-up').addClass('nav-down');
              }
          }
          
          lastScrollTop = st;
      }
    },
    components: {
      SearchForm,
      MoviePanel
    }
  };
</script>

<style lang="scss" scoped>
  .qb-extra-trigger {
    text-align: center;
    padding: 15px 0;
  }
  .qb-extra-wrap {
    padding: 15px;
    margin: -5px -15px -15px;
    position: relative;
    display: none;

    h4 {
      margin-top: 0!important;
    }
    p {
      font-size: 0.9em;
    }
    .numbers-wrap {
      padding-top: 15px;
    }
    .hits-display {
      width: 50%;
      float: left;
      padding: 0 15px 0 40px;
      margin-bottom: 20px;
      box-sizing: border-box;

      h6 {
        color: #397EBF;
      }

      .quality-square {
        background-color: #397EBF;
      }
    }
    .gems-display {
      width: 50%;
      float: right;
      padding: 0 40px 0 15px;
      margin-bottom: 20px;
      box-sizing: border-box;

      h6 {
        color: #EA953F;
      }

      .quality-square {
        background-color: #EA953F;
      }
    }
    h6 {
      margin: 0 0 10px;
      font-size: 0.8em;
    }
    .quality-square {
      float: left;
      width: 46%;
      display: inline-block;
      text-align: center;
      background: #747474;
      color: #fff;
      text-align: center;
      padding: 14px 4px;
      box-sizing: border-box;
      margin-left: 2px;

      span {
        text-decoration: none;
        font-size: 0.7em;
        text-transform: uppercase;
      }
      span.score {
        display: block;
        line-height: 20px;
        text-align: center;
        font-size: 1.4em;
        font-weight: bold;
      }
      &.first {
        margin-left: 0;
      }
    }
  }
  #tutorial-overlay {
    background:rgba(0,0,0,0.7);
    display:none;
    width:100vw;
    height:100vh;
    position:fixed;
    top:0;
    left:0;
    z-index:99998;
  }
  #tutorial-next {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 50%;
    padding: 15px;
    border-radius: 0;
    background-color: #397EBF;
    color: #fff;
    z-index: 999999;
    display: none;
  }
  #tutorial-close {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 50%;
    padding: 15px;
    border-radius: 0;
    background-color: #222;
    color: #fff;
    z-index: 999999;
    display: none;
  }
</style>

<style scoped>
  header {
    background: rgb(41,100,134);
    background: -webkit-gradient(linear, left top, right top, from(rgba(41,100,134,1)), to(rgba(49,129,174,1)));
    background: linear-gradient(90deg, rgba(41,100,134,1) 0%, rgba(49,129,174,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#296486",endColorstr="#3181ae",GradientType=1);
    color: #fff;
    top: -54px;
    height: 54px;
    padding: 15px 20px;
    position: fixed;
    transition: top 0.2s ease-in-out;
    width: 400px;
    max-width: 100%;
    box-sizing: border-box;
    z-index: 99;
  }
  header h5 {
    float: left;
    font-size: 14px;
    margin: 0;
  }
  header h5 > i {
    border: 1px solid #fff;
    color: #fff;
    margin-right: 7px;
    border-radius: 2px;
    padding: 4px;
    font-size: 14px;
  }
  header > div {
    float: right;
  }
  header > div .account-link {
   padding: 0;
  }
  header > div .login-link {
    margin: 0;
    padding: .1em 0.75em;
    font-size: 14px;
  }
  header .pure-menu-list.main-menu {
    float: right;
    margin: -5px -10px 0 0;
    font-size: 20px;
  }
  header .pure-menu-list.main-menu > .pure-menu-item > a {
    padding: 5px 10px;
  }
  header .pure-menu-list.main-menu .pure-menu-children {
    top: 36px;
  }
  .nav-down {
    top: 0;
  }
  #search-form-container {
    width: 100%;
    max-width: 400px;
    padding: 5px 0;
    text-align: left;
    margin: 0 auto;
    background: #EFF3F7;
  }
  .search-form-intro > div {
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    margin: 0 5px 5px;
  }
  .search-form-intro > div.primary-intro {
    padding: 20px 15px;
  }
  .search-form-intro > div.selected-movie {
    padding: 25px 15px;
  }
  .search-form-intro > div.alt h4 {
    margin: 25px 0;
  }
  .search-form-intro .heading-wrap {
    background: rgb(41,100,134);
    background: -moz-linear-gradient(90deg, rgba(41,100,134,1) 0%, rgba(49,129,174,1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(41,100,134,1) 0%, rgba(49,129,174,1) 100%);
    background: linear-gradient(90deg, rgba(41,100,134,1) 0%, rgba(49,129,174,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#296486",endColorstr="#3181ae",GradientType=1);
    color: #fff;
    padding: 20px 15px 10px;
    height: auto;
  }
  .heading-wrap h2 {
    float: left;
  }
  .heading-wrap div {
    float: right;
  }
  .pure-menu-list.main-menu {
    float: right;
    margin: 15px -5px 0 0;
    font-size: 20px;
  }
  .pure-menu-list.main-menu > .pure-menu-item > a {
    cursor: default;
    color: #fff;
  }
  .pure-menu-list.main-menu .pure-menu-children {
    left: auto;
    right: 0;
    top: 46px;
    box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.5);
  }
  .pure-menu-list.main-menu .pure-menu-children > .pure-menu-item {
    border-top: 1px solid #eaeaea;
  }
  .pure-menu-list.main-menu .pure-menu-children > .pure-menu-item:first-child {
    border-top-width: 0;
  }
  .pure-menu-list.main-menu .pure-menu-children .pure-menu-link {
    font-size: 16px;
    padding: 1em 1.3em;
  }
  ..pure-menu-list.main-menu .pure-menu-link {
    color: #fff;
    padding: 13px 18px;
  }
  .pure-menu-list.main-menu .pure-menu-item:hover > .pure-menu-link {
    color: #296486;
    background-color: #fff;
  }
  .pure-menu-has-children>.pure-menu-link:after {
    display: none;
  }
  .account-link {
    padding: 24px 10px 0;
    font-size: 20px;
    color: #fff;
    display: block;
  }
  .login-link {
    background-color: transparent;
    margin: 20px 0 0;
    font-size: 100%;
    padding: .15em 1em;
    color: rgb(255, 255, 255);
    border: 1px solid #fff;
    text-decoration: none;
    border-radius: 2px;
  }
  .search-term {
    box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.5);
    margin: 0 0 20px;
    width: 100%;
  }
  #search-term-top {
    width: 100%;
    padding: 18px 30px;
    font-size: 0.9em;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 0;
  }
  .quality-wrap {
    width: 40%;
    float: left;
    padding: 15px;
    margin: -15px;
    position: relative;
    z-index: 2;
  }
  .buzz-wrap {
    width: 40%;
    float: right;
    padding: 15px;
    margin: -15px;
    position: relative;
    z-index: 2;
  }
  .qb-emphasis {
    display: inline-block;
    box-shadow: 1px 1px 4px -1px rgba(0,0,0,0.6);
    padding: 12px;
    box-sizing: border-box;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
    width: 100%;
    margin-bottom: 10px;
  }
  .quality-buzz-wrap {
    height: auto;
    overflow: hidden;
    padding: 15px;
    margin: -15px;
    position: relative;
  }
  .quality-buzz-wrap p {
    margin-top: 0;
    margin-bottom: 0;
  }
  .quality-buzz-wrap .amp {
    position: absolute;
    z-index: 1;
    width: 100%;
    text-align: center;
    left: 0;
    line-height: 44px;
  }
  .quality-text {
    width: 100%;
    font-size: 0.9em;
    padding: 15px;
    margin: 0 -15px 0;
  }
  .buzz-text {
    width: 100%;
    font-size: 0.9em;
    padding: 15px;
    margin: 0 -15px 0;
  }
  .search-form-intro h4 {
    clear: both;
    line-height: 1.5;
    margin: 10px 0;
  }
  .search-form-intro .two-numbers h4 {
    margin: 25px 0;
  }
  .primary-intro h4 {
    margin-bottom: 20px;
    font-size: 18px;
    padding-top: 15px;
  }
  .primary-intro h4.search-heading {
    padding: 0;
    margin-bottom: 5px;
    font-size: 0.9em;
    line-height: 28px;
  }
  .primary-intro h5 {
    margin: 0 0 15px;
    padding-bottom: 15px;
    color: #3181AD;
    font-size: 16px;
    cursor: pointer;
  }
  .primary-intro h5 i {
    border: 1px solid #222;
    color: #222;
    margin-right: 10px;
    border-radius: 2px;
    padding: 4px;
    font-size: 16px;
  }
  .quality-buzz-wrap + h4 {
    padding-top: 20px;
  }
  .search-form-intro p span {
    font-weight: bold;
  }
  .movie-item {
    opacity: 0;
  }
  .movie-item.item-animated {
    opacity: 1;
  }
  .search-form-intro .movie-row, .search-form-intro .opts-row {
    height: auto;
    overflow: hidden;
    padding: 0;
    background: #EFF3F7;
    min-height: 215px;
  }
  .search-form-intro .popular-movie-row {
    min-height: 292px;
  }
  .popular-movie-row .movie-item {
    cursor: pointer;
  }
  .search-form-intro .opts-row {
    margin-bottom: 0;
  }
  .movie-row ul li .opt-title {
    background: #2C3E50;
    color: #fff;
    padding: 10px;
    font-size: 13px;
    margin-bottom: 5px;
    text-align: center;
    height: 100px;
    display: table;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
  }
  .movie-row ul li .opt-title-inner {
    display: table-cell;
    vertical-align: middle;
    word-break: break-word;
  }
  .movie-row ul {
    list-style: none;
    margin: 0;
    padding: 0;
    margin-left: -5px;
  }
  .movie-row ul li {
    width: 25%;
    float: left;
    padding-left: 5px;
    box-sizing: border-box;
  }
  .movie-row ul li .movie-poster {
    max-height: 110px;
    display: block;
    overflow: hidden;
    cursor: pointer;
  }
  .movie-row ul li img {
    width: 100%;
    height: auto;
    display: block;
  }
  .movie-row ul li .movie-title {
    background: #2C3E50;
    color: #fff;
    padding: 10px;
    font-size: 13px;
    margin-bottom: 5px;
    text-align: center;
    height: 115px;
    display: table;
    width: 100%;
    box-sizing: border-box;
    max-lines: 3;
  }
  .movie-row ul li .movie-title-inner {
    display: table-cell;
    vertical-align: middle;
    word-break: break-word;
  }
  .movie-row ul li .numbers-wrap {
    height: auto;
    overflow: hidden;
    margin-top: 5px;
  }
  .movie-row ul li .numbers-wrap .quality-square {
    float: right;
    width: 49%;
    display: inline-block;
    text-align: center;
    background: #747474;
    color: #fff;
    text-align: center;
    padding: 8px 4px;
    box-sizing: border-box;
  }
  .movie-row ul li[data-class="high"] .numbers-wrap .quality-square {
    background: #397EBF;
  }
  .movie-row ul li[data-class="mid"] .numbers-wrap .quality-square {
    background: #EA953F;
  }
  .movie-row ul li .numbers-wrap .quality-square span {
    text-decoration: none;
    font-size: 0.5em;
    text-transform: uppercase;
  }
  .movie-row ul li .numbers-wrap span.score {
    display: block;
    line-height: 16px;
    text-align: center;
    font-size: 1.1em;
    font-weight: bold;
    margin: 5px 0 0;
  }
  .movie-row ul li .numbers-wrap .quality-square:first-child {
    float: left;
  }
  .refresh-trigger {
    float: right;
    margin: -2px 0;
    padding: 0 10px;
    font-size: 20px;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/Search.vue